// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4040fcad","455":"068289fc","977":"28106f8d"}[chunkId] + ".chunk.js";
};